import { render, staticRenderFns } from "./IcoScrollDown.vue?vue&type=template&id=4be3525e&"
import script from "./IcoScrollDown.vue?vue&type=script&lang=js&"
export * from "./IcoScrollDown.vue?vue&type=script&lang=js&"
import style0 from "./IcoScrollDown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports